import React from 'react'
import Button from '../../components/General/Button'
import { ISuscription } from './Suscriptions'
import { formatPipe } from '../../utils/utils'

const SuscriptionView = ({ onClose, suscription }: { onClose: () => void; suscription: ISuscription }) => {
  const frequencyOptions = {
    monthly: 'Mensual',
    weekly: 'Semanal',
    biweekly: 'Quincenal',
    quarterly: 'Trimestral',
    annual: 'Anual',
  }

  const ivaTypeOptions = {
    GENERAL: 'General',
    REDUCED: 'Reducido',
    EXEMPT: 'Exento',
  }

  return (
    <div className="gap-y-6 flex flex-col">
      {/* Header */}
      <div className="col-span-12" style={{ fontWeight: 500, fontSize: '18px' }}>
        Vista de suscripción
      </div>

      {/* Basic Information Section */}
      <div>
        <div className="col-span-12" style={{ fontWeight: 500, marginBottom: '16px' }}>
          Información Básica
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-3">
          <div>
            <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
              Nombre de la Suscripción
            </label>
            <p className="text-sm text-gray-900 dark:text-white font-medium">
              {suscription?.description || '-'}
            </p>
          </div>

          <div>
            <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
              Frecuencia de Pago
            </label>
            <p className="text-sm text-gray-900 dark:text-white font-medium">
              {frequencyOptions[suscription?.frequency] || '-'}
            </p>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div>
        <div className="col-span-12" style={{ fontWeight: 500, marginBottom: '16px' }}>
          Configuración de Precios
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-3">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                Precio
              </label>
              <p className="text-sm text-gray-900 dark:text-white font-medium">
                $ {formatPipe(suscription?.total) || '0,00'}
              </p>
            </div>

            <div>
              <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                Tipo de IVA
              </label>
              <p className="text-sm text-gray-900 dark:text-white font-medium">
                {ivaTypeOptions[suscription?.ivaType] || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Articles/Services Section */}
      <div>
        <div className="col-span-12" style={{ fontWeight: 500, marginBottom: '16px' }}>
          Artículos y Servicios
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
          {suscription?.items && suscription.items.length > 0 ? (
            <div className="space-y-2">
              {suscription.items.map((item: any, index: number) => (
                <div
                  key={index}
                  className="bg-white dark:bg-gray-900 rounded-lg p-3 flex justify-between items-center"
                >
                  <div className="flex-1">
                    <p className="text-sm text-gray-900 dark:text-white font-medium">
                      {item.name}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      Tipo: {item.type === 'product' ? 'Artículo' : 'Servicio'}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-gray-500 dark:text-gray-400">Cantidad</p>
                    <p className="text-sm text-gray-900 dark:text-white font-medium">
                      {item.amount}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-4">
              No hay artículos o servicios asociados
            </p>
          )}
        </div>
      </div>

      {/* Settings Section */}
      <div>
        <div className="col-span-12" style={{ fontWeight: 500, marginBottom: '16px' }}>
          Configuración
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
          <div>
            <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
              Estado
            </label>
            <div className="flex items-center">
              <span
                className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                  suscription?.active
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                    : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                }`}
              >
                {suscription?.active ? 'Habilitado' : 'Inhabilitado'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      {/* Action Button */}
      <div className="col-span-12 h-full flex flex-row mt-4">
        <div className="w-full">
          <Button type="outline" classes="w-full" onClick={onClose}>
            Cerrar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SuscriptionView
